import React from "react";
import { Box } from "../../../../../components/MuiGenerals";

const InnerContent = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="inner-content">
      <Box
        sx={{
          ".MuiInputBase-root": { backgroundColor: "#f1f2f4" },
          ".MuiInputLabel-root": { color: "#A2A2A2" },
          ".MuiFormControl-root": { width: "100%" },
        }}
      >
        {children}
      </Box>
    </div>
  );
};

export default InnerContent;
